export default "__VITE_ASSET__Dr6L3to5__"